import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const MaterialStorageService = {
    options: async () => axios.get(`${API_URL}/material-storages/options/all`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
    optionsByUser: async () => axios.get(`${API_URL}/material-storages/options-by-user/all`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
    optionsUsersByStorages: async (storage) => axios.get(`${API_URL}/users/options-by-storage/${storage}`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
    list: async () => axios.post(`${API_URL}/material-storages/list`).then(({data}) => data).catch((err) => { throw err }),
    getById: async (id) => axios.get(`${API_URL}/material-storages/${id}`).then(({data}) => data).catch((err) => { throw err }),
    delete: async (id) => axios.delete(`${API_URL}/material-storages/${id}`).then(({data}) => data).catch((err) => {throw err}),
    save: async (formData, id) => {
        if (id) {
            formData.append('_method', 'PUT');
            return axios.post(`${API_URL}/material-storages/${id}`, formData).then(({data}) => data).catch((err) => { throw err })
        }

        return axios.post(`${API_URL}/material-storages`, formData).then(({data}) => data).catch((err) => { throw err })
    },
}

export default MaterialStorageService;